import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../usersContext';

export function useStripeConnectRedirect() {
  const { userStatus, userDoc } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Don't redirect if we're already on Stripe-related pages
    const stripePages = ['/stripe-connect-onboarding', '/stripe-connect-return'];
    if (stripePages.includes(location.pathname)) {
      return;
    }
    
    // Check if user is a verified tutor without Stripe Connect
    if (userStatus === 'verified' && userDoc?.userType === 'tutor') {
      const needsStripeSetup = !userDoc.stripeConnectAccountId || 
                               (userDoc.stripeConnectStatus !== 'active' && 
                                userDoc.stripeConnectStatus !== 'pending_verification');
      
      if (needsStripeSetup) {
        navigate('/stripe-connect-onboarding', { replace: true });
      }
    }
  }, [userStatus, userDoc, navigate, location.pathname]);
}